
<template>
  <div>
    <div class="box box-primary">
      <div class="box-header with-border">
        <h3 class="box-title"><b>{{this.getFullNameByLanguage(null)}} - {{this.item.apartment.apartment_code}} - {{this.item.apartment.size}} {{ $t(`apartment.m2`) }} </b></h3>
        <!-- <h3 class="box-title pull-right">{{ $t(`apartment.${resident_type}title`) }}</h3> -->
        <button
            type="button"
            class="btn btn-labeled btn-primary pull-right"
            @click="onClickOpenApartment"
            style="margin-right: 5px;"
          >
            <span class="btn-label">
              <i class="glyphicon glyphicon-home"></i>
            </span>
            {{ $t(`apartment.${resident_type}title`) }}
          </button>
      </div>

      <div class="box-body">
        <div class="row">
          <div class="col-sm-12">
            <!-- <b>{{this.getFullNameByLanguage(null)}}</b> -->
            <!-- <br /> -->
            <div class="row">
              <div class="col-md-4 col-lg-4">
                <b>{{$t('customer.username')}}:</b>
                {{(resident_type == 'tenant' ? tenant : main_person).resident.username}}
                <br />
                <b>{{$t('customer.fullname')}}:</b>
                {{this.getFullNameByLanguage(null)}}
                <br />
                <b>{{$t('customer.email')}}:</b>
                {{(resident_type == 'tenant' ? tenant : main_person).resident.email}}
                <br />
                <b>{{$t('customer.phone')}}:</b>
                {{(resident_type == 'tenant' ? tenant : main_person).resident.phone}}
              </div>
              <div class="col-md-4 col-lg-4">
                <b>{{$t('customer.gender')}}:</b>
                {{$t((resident_type == 'tenant' ? tenant : main_person).resident.gender)}}
                <br />
                <b>{{$t('customer.dob')}}:</b>
                {{day_of_birth}}
                <br />
                <b>{{$t('customer.country')}}:</b>
                {{(resident_type == 'tenant' ? tenant : main_person).resident.country_name}}
                <br />
                <!-- <b>{{$t('customer.current_debt')}}:</b>
                {{current_debt}} vnđ -->
              </div>
              <div class="col-md-4 col-lg-4">
                <b>{{$t('apartment.e_figure')}}:</b>
                {{(resident_type == 'tenant' ? tenant : main_person).start_efigure}}
                <br />
                <b>{{$t('apartment.w_figure')}}:</b>
                {{(resident_type == 'tenant' ? tenant : main_person).start_wfigure}}
                <br />
                <b>{{$t('apartment.move_in')}}:</b>
                {{day_move_in}}
                <br />
                <b>{{$t('apartment.move_out')}}:</b>
                {{day_move_out}}
              </div>
            </div>
          </div>
        </div>
        <br />
        <br />
        <div class="row" v-show="isShowRelatives(resident_items)">
          <div class="col-sm-12">
            <b>{{$t('apartment.relatives')}}:</b>
            <br />
            <br />
            <div class="col-xs-12 table-responsive">
              <b-table :items="resident_items" :fields="resident_fields" class="mt-3" outlined>
                <!-- <template
                  v-for="index in resident_fields"
                  :slot="'HEAD_' + index.key"
                  slot-scope="item"
                >{{ $t(item.label) }}</template> -->
                <template #head()="scope">
                  <div>{{ $t(scope.label) }}</div>
                </template>
              </b-table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <lte-core-alert v-for="snackbar in GET_SNACK_BAR" :key="snackbar.id" :item="snackbar"></lte-core-alert>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
// import moment from "moment";
//import datePicker from "vue-bootstrap-datetimepicker";
import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";
import LTECoreAlert from "@/components/LTESnackBar.vue";
import constants from "@/lib/constantsData";
import i18n from '../../lang';
import utils from '@/lib/utils';


// Import EventBus.
// import { EventBus } from './event-bus.js';

export default {
  name: "SearchApartmentInfo",
  props: {
    apartment_id: {
      type: Number,
      default: () => {
        return 0;
      }
    },
    resident_type: {
      type: String,
      default: () => {
        return "owner";
      }
    },
    item: {
      type: Object
    },
  },
  data() {
    return {
      main_person: {
        id: 0,
        resident: {
          id: null,
          first_name: "",
          last_name: "",
          email: "",
          username: "",
          phone: "",
          country_name: "",
          dob: null,
          gender: 0
        },
        resident_movein: null,
        resident_moveout: null,
        start_efigure: 0,
        start_wfigure: 0,
        resident_status: null,
        available_customers: []
      },
      tenant: {
        id: 0,
        resident: {
          id: 0,
          first_name: "",
          last_name: "",
          email: "",
          username: "",
          phone: "",
          country_name: "",
          dob: null,
          gender: 0
        },
        resident_movein: null,
        resident_moveout: null,
        start_efigure: 0,
        start_wfigure: 0,
        resident_status: null,
        available_customers: []
      },
      selected_relative_person: {
        id: 0,
        resident: {
          id: null,
          first_name: "",
          last_name: "",
          email: "",
          username: "",
          phone: "",
          country_name: "",
          dob: null,
          gender: 0
        },
        relationship: null,
        resident_status: null,
        relationship_note: null
      },
      residentStatusOptions: constants.residentStatusOptions,
      dateOptions: {
        format: "DD/MM/YYYY"
      },
      customers: [],
      resident_items: [],
      resident_fields: [
        {
          key: "full_name",
          label: "apartment.fullname",
          sortable: true,
          class: "text-center"
        },
        {
          key: "phone",
          label: "apartment.phone",
          sortable: true,
          class: "text-center"
        },
        {
          key: "email",
          label: "apartment.email",
          sortable: true,
          class: "text-center"
        },
        {
          key: "country",
          label: "apartment.country",
          sortable: true,
          class: "text-center"
        },
        {
          key: "underAge",
          label: "customer.age",
          sortable: true,
          class: "text-center"
        },
        {
          key: "resident_status",
          label: "common.status",
          sortable: true,
          class: "text-center"
        },
        {
          key: "relationship",
          label: "apartment.relationship",
          sortable: true,
          class: "text-center"
        },
        {
          key: "relationship_note",
          label: "common.note",
          sortable: true,
          class: "text-center"
        },
        { key: "actions", label: "common.action", class: "text-center" }
      ],
      radioOptions: [
        { text: "Đổi", value: true },
        { text: "Không", value: false }
      ],
      isExistMonthlyUsage: false,
      updateNewMain: false,
      itemCustomer: {
        data_list: [],
        itemType: 0,
        showLabel: false,
        modifyFromPosition: "margin-top:-300px",
        cssClassSm1: "col-md-3",
        cssClassSm2: "col-sm-6",
        showAddNew: false
      },
      current_debt: 0
    };
  },
  watch: {
    // GET_RESIDENT_DATA: function() {
    //   // get main person & relatives of main person
    //   let main_person = "";
    //   let tenant = "";
    //   let relatives = [];
    //   for (let i = 0, size = this.GET_RESIDENT_DATA.length; i < size; i++) {
    //     let resident = this.GET_RESIDENT_DATA[i];
    //     if (
    //       this.resident_type === "owner" &&
    //       (resident.isOwner == "Yes" || resident.isOwner == true)
    //     ) {
    //       main_person = resident;
    //     } else if (
    //       this.resident_type === "tenant" &&
    //       (resident.isTenant == "Yes" || resident.isTenant == true)
    //     ) {
    //       tenant = resident;
    //     }
    //     relatives.push(resident);
    //   }
    //   // refresh main person details
    //   if (!main_person) {
    //     main_person = {
    //       id: 0,
    //       resident: {
    //         id: null,
    //         first_name: "",
    //         last_name: "",
    //         email: "",
    //         username: "",
    //         phone: "",
    //         country_name: "",
    //         dob: null,
    //         identificationnumber: "",
    //         gender: 0
    //       },
    //       resident_movein: null,
    //       resident_moveout: null,
    //       start_efigure: 0,
    //       start_wfigure: 0,
    //       resident_status: null
    //     };
    //   } else if (!tenant) {
    //     tenant = {
    //       id: 0,
    //       resident: {
    //         id: 0,
    //         first_name: "",
    //         last_name: "",
    //         email: "",
    //         username: "",
    //         phone: "",
    //         country_name: "",
    //         dob: null,
    //         identificationnumber: "",
    //         gender: 0
    //       },
    //       resident_movein: null,
    //       resident_moveout: null,
    //       start_efigure: 0,
    //       start_wfigure: 0,
    //       resident_status: null
    //     };
    //   }
    //   this.getMainPerson(main_person);
    //   this.getTenant(tenant);
    //   // refresh relatives
    //   this.getRelatives(relatives);
    // },
    // apartment_id: function() {
    //   let apartment_id = this.apartment_id;
    //   if (parseInt(apartment_id) !== 0) {
    //     this.getResidents(apartment_id);
    //   }
    // },
    // APARTMENT_MONTHLY_USAGE_DATA: function() {
    //   for (let i = 0, size = this.APARTMENT_MONTHLY_USAGE_DATA.length; i < size; i++) {
    //     let monthlyUsage = utils.formatSqlDate(this.APARTMENT_MONTHLY_USAGE_DATA[i].date_to, null, "MM/YYYY");
    //     let monthNow = moment(new Date()).format("MM/YYYY");
    //     //Check disable if exist monthly usage > month now
    //     if (monthlyUsage < monthNow) {
    //       this.isExistMonthlyUsage = true
    //       break;
    //     }
    //   }
    // }
  },
  computed: {
    ...mapGetters([
      "GET_SNACK_BAR",
      "GET_ACCOUNT_DATA"
    ]),
    day_of_birth: function() {
      return utils.formatSqlDate((this.resident_type == "tenant" ? this.tenant : this.main_person).resident.dob, null, this.dateOptions.format);
    },
    day_move_in: function() {
      return utils.formatSqlDate((this.resident_type == "tenant" ? this.tenant : this.main_person).resident_movein, null, this.dateOptions.format);
    },
    day_move_out: function() {
      return utils.formatSqlDate((this.resident_type == "tenant" ? this.tenant : this.main_person).resident_moveout, null, this.dateOptions.format);
    },
    available_customers: function() {
      let available_customers = [];
      for (let i = 0; i < this.customers.length; i++) {
        let customer = this.customers[i];
        let exist_ind = false;
        for (let j = 0; j < this.GET_RESIDENT_DATA.length; j++) {
          let resident = this.GET_RESIDENT_DATA[j];
          if (resident.resident.id === customer.value) {
            exist_ind = true;
          }
        }
        if (!exist_ind) {
          available_customers.push(customer);
        }
      }
      this.setAvailableCustomers(available_customers);
      return available_customers;
    },
    main_person_full_name: function() {
      if (utils.isEnglishLanguage(i18n.locale)) {
        return `${
          (this.resident_type == "tenant" ? this.tenant : this.main_person)
            .resident.first_name
        } ${
          (this.resident_type == "tenant" ? this.tenant : this.main_person)
            .resident.last_name
        }`;
      } else {
        return `${
          (this.resident_type == "tenant" ? this.tenant : this.main_person)
            .resident.last_name
        } ${
          (this.resident_type == "tenant" ? this.tenant : this.main_person)
            .resident.first_name
        }`;
      }
    },
  },
  methods: {
    ...mapActions([
      // "GET_CUSTOMER_LIST",
      "ON_SHOW_TOAST",
      "SUCCESS_TOAST"
      // "GET_APARTMENT_MONTHLY_USAGE"
    ]),
    onClickOpenApartment: function() {
      let routeData = this.$router.resolve({
        name: "ApartmentAdd",
        params: {
          id: this.item.apartment.id
        }
      });
      window.open(routeData.href, "_blank");
    },
    isShowRelatives: function(resident_items){
        return resident_items.length > 0 
    },
    has_perm: function(perm){
      return utils.has_perm(this.GET_ACCOUNT_DATA, perm)
    },
    getFullNameByLanguage(data){
      if (data != null) {
        return utils.getFullName(data.first_name, data.last_name, i18n.locale)
      } else {
        return utils.getFullName(((this.resident_type == 'tenant' ? this.tenant : this.main_person).resident.first_name), ((this.resident_type == 'tenant' ? this.tenant : this.main_person).resident.last_name), i18n.locale)
      }
    },
    relative_status_name: function(status_id) {
      for (let i = 0; i < this.residentStatusOptions.length; i++) {
        let status = this.residentStatusOptions[i];
        if (status.value === status_id) {
          return status.text;
        }
      }
      return status_id;
    },
    setAvailableCustomers: function(data) {
      if (data !== undefined) {
        this.itemCustomer.data_list = data;
      }
    },
    set_current_debt_status(index){
      return (index == 0 && this.current_debt != 0) ? true : false
    }

  },
  mounted() {
    this.main_person = this.item
    let gender = this.item.resident.gender
    gender = gender !== 0
                  ? gender == 1
                    ? "customer.gender_type[0]"
                    : gender == 2
                      ? "customer.gender_type[1]"
                      : "customer.gender_type[2]"
                  : ""
    this.main_person.resident.gender = gender

    // // loitt add send_monthlyusage_items #320 check current_debt
    // EventBus.$on('send_monthlyusage_items', data => {
    //   let monthlyusage_item_invoice_not_paid  = data.filter(item => item.invoice_number != '' && item.status != 'paid')
    //   let totalFee = 0;
    //   monthlyusage_item_invoice_not_paid.forEach(function(v) {
    //     totalFee +=  parseInt(utils.formatInteger(v.total_fee))
    //   })
    //   this.current_debt = utils.formatNumber(utils.makeRoundNumber(totalFee))
    // });

    // this.GET_CUSTOMER_LIST().then(
    //   function(res) {
    //     let customerList = res.data;
    //     let customers = [{ value: null, text: "---" }];
    //     customerList.forEach(data => {
    //       let full_name = this.getFullNameByLanguage(data)
    //       let item = {
    //         value: data.id,
    //         text: full_name,
    //         email: data.email,
    //         dob: data.profile ? moment(data.profile.dob).format("DD/MM/YYYY") : null,
    //         phone: data.profile ? data.profile.phone : null,
    //         passport: data.profile ? data.profile.passport : null
    //       };
    //       customers.push(item);
    //     });
    //     this.customers = customers;
    //     let apartment_id = this.apartment_id;
    //     if (parseInt(apartment_id) !== 0) {
    //       this.getResidents(apartment_id);
    //     }
    //   }.bind(this)
    // );
    //Get apartment monthly usage
    // const filter = {
    //   params: {
    //     page: 1,
    //     apartmentid:  this.$route.params.id
    //   }
    // };
    // this.GET_APARTMENT_MONTHLY_USAGE(filter).then(
    //   function(res) {
    //   }.bind(this)
    // );
  },
  components: {
    //"date-picker": datePicker,
    "lte-core-alert": LTECoreAlert
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.margin-down-15 {
  margin-bottom: 15px;
}

.row {
  margin-right: 0px;
  margin-left: 0px;
}

.custom-control-inline {
  display: inline-flex;
  margin-right: 1rem;
}

.label-red {
  background-color: red !important;
}
</style>



// WEBPACK FOOTER //
// src/views/Search/SearchApartmentInfo.vue